import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-scroll--right",
  "use": "icon-scroll--right-usage",
  "viewBox": "0 0 17 25",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 25\" id=\"icon-scroll--right\"><path d=\"M12.497 11.089c.83-.77 2.175-.77 3.005 0 .415.384.623.889.623 1.393 0 .505-.207 1.009-.623 1.394L4.167 24.387c-2.004 1.858-5.01-.929-3.006-2.787l11.336-10.511v2.787L1.16 3.365a1.871 1.871 0 0 1 0-2.788c.83-.77 2.176-.77 3.006 0L15.502 11.09c.415.384.623.889.623 1.393 0 .505-.207 1.009-.623 1.394L4.167 24.387 1.16 21.6l11.336-10.511Z\" fill=\"#002D72\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol